(function () {
  if (window.__mpnTabs) return; window.__mpnTabs = true;
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var T = {
    fr: { pose: 'Guide de pose', poseS: 'Méthodes, étapes et conseils', care: 'Guide d’entretien', careS: 'Nettoyer et protéger votre pierre', acc: 'Colle, joints, protection :', accL: 'voir les produits conseillés pour ce produit ↑' },
    en: { pose: 'Installation guide', poseS: 'Methods, steps and tips', care: 'Care guide', careS: 'Clean and protect your stone', acc: 'Adhesive, grout, protection:', accL: 'see the recommended products for this item ↑' },
    de: { pose: 'Verlegeanleitung', poseS: 'Methoden, Schritte und Tipps', care: 'Pflegeanleitung', careS: 'Ihren Naturstein reinigen und schützen', acc: 'Kleber, Fugen, Schutz:', accL: 'empfohlene Produkte für diesen Artikel ansehen ↑' }
  }[lang] || null;
  if (!T) T = { pose: 'Guide de pose', poseS: 'Méthodes, étapes et conseils', care: 'Guide d’entretien', careS: 'Nettoyer et protéger votre pierre', acc: 'Colle, joints, protection :', accL: 'voir les produits conseillés pour ce produit ↑' };
  var IC_POSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 21h18"/><path d="M5 21V10l7-6 7 6v11"/><path d="M9 21v-6h6v6"/></svg>';
  var IC_CARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z"/></svg>';
  var RE_LEVEL = /\(\s*([1-4])\s*\/\s*4\s*\)/;
  var RE_POSE = /conseils-de-pose|\/pose|installation|verleg/i;
  var RE_CARE = /entretien|entretenir|soin|care|maintenance|pflege|reinig/i;

  function gauges() {
    /* uniquement l'onglet « Variation de teintes » (bloc collapsible_tab_BGL7XR de templates/product.json) */
    document.querySelectorAll('details[id^="Details-collapsible_tab_BGL7XR"] .accordion__content :is(h4, h5, h6)').forEach(function (h) {
      if (h.dataset.mpnGauge) return;
      var m = (h.textContent || '').match(RE_LEVEL);
      if (!m) return;
      h.dataset.mpnGauge = '1';
      var n = parseInt(m[1], 10);
      /* on retire seulement « (n/4) » du titre ; le texte d'Ed reste intact */
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (RE_LEVEL.test(node.nodeValue)) { node.nodeValue = node.nodeValue.replace(RE_LEVEL, '').replace(/\s+$/, ''); break; }
      }
      var inner = document.createElement('span');
      while (h.firstChild) inner.appendChild(h.firstChild);
      h.appendChild(inner);
      var g = document.createElement('span');
      g.className = 'mpn-gauge';
      g.setAttribute('aria-label', n + '/4');
      var bars = '';
      for (var i = 1; i <= 4; i++) bars += '<i' + (i <= n ? ' class="on"' : '') + '></i>';
      g.innerHTML = '<span aria-hidden="true">' + bars + '</span><span>' + n + '/4</span>';
      h.appendChild(g);
      h.classList.add('mpn-var-h');
    });
    /* Ce qui precede le 1er critere (introduction + lien « En savoir plus ») passe en fin d'onglet, en note : rien n'est supprime */
    document.querySelectorAll('details[id^="Details-collapsible_tab_BGL7XR"] .accordion__content').forEach(function (box) {
      if (box.dataset.mpnVarNote) return;
      var first = box.querySelector('.mpn-var-h');
      if (!first) return;
      box.dataset.mpnVarNote = '1';
      var parent = first.parentElement, moving = [];
      for (var el = parent.firstElementChild; el && el !== first; el = el.nextElementSibling) moving.push(el);
      moving.forEach(function (el, i) { el.classList.add('mpn-var-note'); if (i === 0) el.classList.add('is-first'); parent.appendChild(el); });
    });
  }

  function guides() {
    /* uniquement l'onglet « Conseils de pose & d'entretien » (bloc collapsible_tab_BDwrVw) : jamais la Description */
    document.querySelectorAll('details[id^="Details-collapsible_tab_BDwrVw"] .accordion__content').forEach(function (box) {
      if (box.dataset.mpnGuides) return;
      var links = [].slice.call(box.querySelectorAll('a[href*="/blogs/"]'));
      if (!links.length) return;
      /* Tous les liens « guide de pose » et « guide d'entretien » (ex. Intérieur | Extérieur) */
      var poses = [], cares = [], seen = {};
      links.forEach(function (a) {
        var h = a.getAttribute('href') || '';
        if (seen[h]) return;
        var k = h + ' ' + a.textContent;
        if (RE_CARE.test(k) && !/conseils-de-pose/i.test(h)) { cares.push(a); seen[h] = 1; }
        else if (RE_POSE.test(k)) { poses.push(a); seen[h] = 1; }
      });
      if (!poses.length && !cares.length) return;
      box.dataset.mpnGuides = '1';
      var guideLinks = poses.concat(cares);
      var wrap = document.createElement('div');
      wrap.className = 'mpn-guides';
      function label(a) {
        var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (t && t === t.toUpperCase()) t = t.charAt(0) + t.slice(1).toLowerCase();
        return t;
      }
      function card(list, ic, t, sub) {
        if (!list.length) return;
        var c;
        if (list.length === 1) {
          c = document.createElement('a');
          c.className = 'mpn-guide';
          c.href = list[0].getAttribute('href');
          if (list[0].target) c.target = list[0].target;
          c.innerHTML = '<span class="mpn-guide__ico">' + ic + '</span><span><span class="mpn-guide__t">' + t + '</span><span class="mpn-guide__s">' + sub + '</span></span><span class="mpn-guide__a" aria-hidden="true">›</span>';
        } else {
          /* plusieurs guides (ex. intérieur / extérieur) : une seule carte, un lien par guide */
          c = document.createElement('div');
          c.className = 'mpn-guide mpn-guide--multi';
          var l = list.map(function (a) {
            return '<a href="' + a.getAttribute('href') + '"' + (a.target ? ' target="' + a.target + '"' : '') + '>' + label(a) + ' ›</a>';
          }).join('');
          c.innerHTML = '<span class="mpn-guide__ico">' + ic + '</span><span><span class="mpn-guide__t">' + t + '</span><span class="mpn-guide__l">' + l + '</span></span>';
        }
        wrap.appendChild(c);
      }
      card(poses, IC_POSE, T.pose, T.poseS);
      card(cares, IC_CARE, T.care, T.careS);
      /* Paragraphes qui ne servaient qu'a ces liens (« Decouvrez nos guides... : INTERIEUR | EXTERIEUR ») : masques ;
         tout autre texte est conserve */
      guideLinks.forEach(function (a) {
        var blk = a.closest('p, h1, h2, h3, h4, h5, h6, li') || a.parentElement;
        if (!blk || !box.contains(blk) || blk.dataset.mpnHid) return;
        var all = [].slice.call(blk.querySelectorAll('a'));
        if (all.some(function (x) { return guideLinks.indexOf(x) === -1; })) return;
        var rest = blk.textContent || '';
        all.forEach(function (x) { rest = rest.replace(x.textContent, ''); });
        rest = rest.replace(/[|·•\-–—,:\s]/g, '');
        if (rest.length >= 70) return;
        blk.style.display = 'none'; blk.dataset.mpnHid = '1';
        /* l'intro juste avant (« Decouvrez nos guides de pose : »), sans lien, courte : masquee aussi */
        var prev = blk.previousElementSibling;
        if (prev && !prev.dataset.mpnHid && !prev.querySelector('a') && /guide|anleitung/i.test(prev.textContent || '') && (prev.textContent || '').trim().length < 140) {
          prev.style.display = 'none'; prev.dataset.mpnHid = '1';
        }
      });
      box.insertBefore(wrap, box.firstChild);
      if (document.querySelector('pose-accessories, .pose-accessories')) {
        var acc = document.createElement('p');
        acc.className = 'mpn-guides-acc';
        acc.innerHTML = T.acc + ' <a role="button" tabindex="0">' + T.accL + '</a>';
        acc.querySelector('a').addEventListener('click', function (e) {
          e.preventDefault();
          /* bloc « Pose & entretien » visible, centre a l'ecran (sous le menu fixe), avec un bref repere */
          var pa = [].filter.call(document.querySelectorAll('pose-accessories, .pose-accessories'), function (x) { return x.getClientRects().length; })[0];
          if (!pa) return;
          /* Ouvre directement la liste des produits conseilles (accordeon ferme par defaut), puis
             cale le haut du bloc sous le menu fixe une fois la liste deployee (demande d'Ed, oct. 2026) */
          var tg = pa.querySelector('[data-accordion-toggle]');
          var wasClosed = tg && tg.getAttribute('aria-expanded') !== 'true';
          if (wasClosed) tg.click();
          setTimeout(function () {
            var r = pa.getBoundingClientRect();
            var head = document.querySelector('.section-header, sticky-header, header');
            var hh = head ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
            var room = window.innerHeight - hh;
            var y = r.height < room - 32
              ? window.scrollY + r.top - hh - (room - r.height) / 2
              : window.scrollY + r.top - hh - 16;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
            pa.style.transition = 'box-shadow .3s ease';
            pa.style.boxShadow = '0 0 0 2px #4f7a00';
            setTimeout(function () { pa.style.boxShadow = ''; }, 1600);
          }, wasClosed ? 380 : 0);
        });
        wrap.after(acc);
      }
    });
  }

  function run() { try { gauges(); guides(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  setTimeout(run, 1500);
})();
